import { domain } from 'modules/data';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

export const useIsInRoles = (roleOrRoles: domain.CompanyUserRole[] | domain.CompanyUserRole) => {
    const company = useCompanyBasedOnUrl();

    return (Array.isArray(roleOrRoles) ? roleOrRoles : [roleOrRoles]).includes(company.myRole);
};
